var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCondoBuilding = function SvgCondoBuilding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 440 512",
    style: {
      enableBackground: "new 0 0 440 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#456E89;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368,116H258c-5.5,0-10,4.5-10,10v110v120c0,5.5,4.5,10,10,10h110c5.5,0,10-4.5,10-10V236V126 C378,120.5,373.5,116,368,116z M308,226v-90h10v90H308z M358,246v10h-90v-10H358z M358,276v10h-90v-10H358z M268,306h90v10h-90V306z  M358,226h-20v-90h20V226z M268,136h20v90h-20V136z M268,346v-10h90v10H268z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,476H28c-5.5,0-10,4.5-10,10s4.5,10,10,10h50h40h240h50c5.5,0,10-4.5,10-10V86c0-5.5-4.5-10-10-10H278V26 c0-5.5-4.5-10-10-10H108c-5.5,0-10,4.5-10,10v60v210H58c-5.5,0-10,4.5-10,10v90c0,5.5,4.5,10,10,10h10v70H58 M258,36v40h-40 c-5.5,0-10,4.5-10,10v20h-40V86c0-5.5-4.5-10-10-10h-40V36H258z M348,446H128v-10h220V446z M128,466h220v10H128V466z M348,416H128 v-10h90h130V416z M148,106h-30V96h30V106z M168,166v-10h40v10H168z M208,186v10h-40v-10H208z M148,166h-30v-10h30V166z M148,186v10 h-30v-10H148z M148,216v10h-30v-10H148z M168,216h40v10h-40V216z M208,136h-40v-10h40V136z M148,136h-30v-10h30V136z M118,246h30v10 h-30V246z M168,246h40v10h-40V246z M208,276v20h-40v-20H208z M118,276h30v20h-30V276z M68,316h40h50h50v70h-90H78H68V316z M88,476 v-70h20v70H88z M368,476v-80c0-5.5-4.5-10-10-10H228v-80V96h40h130v380H368z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCondoBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/condoBuilding.40b6b6ab.svg";
export { ForwardRef as ReactComponent };